import { type ReactNode } from 'react'
import { AnimatePresence, motion, useReducedMotion } from 'motion/react'

// Spacing around the panel must be padding on its child: a flex `gap` survives
// the collapse, and a child margin jumps in and out of the animated height.
export const CollapsiblePanel = ({
  isOpen,
  children,
}: {
  isOpen: boolean
  children: ReactNode
}) => {
  const shouldReduceMotion = useReducedMotion()

  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          initial='hidden'
          animate='visible'
          exit='hidden'
          variants={{
            hidden: { opacity: 0, height: 0 },
            visible: { opacity: 1, height: 'auto' },
          }}
          transition={shouldReduceMotion ? { duration: 0 } : undefined}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
